import React from 'react';
import { STUDIO_COPY } from '../config';

const IconLink: React.FC = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

const IconPlay: React.FC = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polygon points="8 5 8 19 19 12" />
    <path d="M19 4v4M17 6h4" />
  </svg>
);

const IconShare: React.FC = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <path d="M8.6 13.5l6.8 4M8.6 10.5l6.8-4" />
  </svg>
);

const STEPS = [
  {
    n: 1,
    icon: <IconLink />,
    title: STUDIO_COPY.publicWatchStep1Title,
    body: STUDIO_COPY.publicWatchStep1Body,
  },
  {
    n: 2,
    icon: <IconPlay />,
    title: STUDIO_COPY.publicWatchStep2Title,
    body: STUDIO_COPY.publicWatchStep2Body,
  },
  {
    n: 3,
    icon: <IconShare />,
    title: STUDIO_COPY.publicWatchStep3Title,
    body: STUDIO_COPY.publicWatchStep3Body,
  },
];

const PROOF = [
  {
    stat: STUDIO_COPY.publicWatchProof1Stat,
    line: STUDIO_COPY.publicWatchProof1Line,
  },
  {
    stat: STUDIO_COPY.publicWatchProof2Stat,
    line: STUDIO_COPY.publicWatchProof2Line,
  },
  {
    stat: STUDIO_COPY.publicWatchProof3Stat,
    line: STUDIO_COPY.publicWatchProof3Line,
  },
];

/**
 * Direction B marketing block below the public reel player.
 */
const PublicWatchHowItWorks: React.FC = () => {
  return (
    <section
      className="rtts-public-how"
      data-testid="rtts-public-how"
      aria-labelledby="rtts-how-heading"
    >
      <h2 className="rtts-public-how-heading" id="rtts-how-heading">
        {STUDIO_COPY.publicWatchHowHeading}
      </h2>
      <p className="rtts-public-how-sub">{STUDIO_COPY.publicWatchHowSubhead}</p>
      <div className="rtts-public-steps">
        {STEPS.map((step) => (
          <article className="rtts-public-step" key={step.n}>
            <div className="rtts-public-icon-tile" aria-hidden="true">
              {step.icon}
            </div>
            <span className="rtts-public-eyebrow">STEP {step.n}</span>
            <h3>{step.title}</h3>
            <p>{step.body}</p>
          </article>
        ))}
      </div>
      <div className="rtts-public-proof">
        {PROOF.map((tile) => (
          <div className="rtts-public-proof-tile" key={tile.stat}>
            <div className="rtts-public-proof-stat">{tile.stat}</div>
            <p className="rtts-public-proof-line">{tile.line}</p>
          </div>
        ))}
      </div>
      <div className="rtts-public-how-cta-wrap">
        <a
          className="rtts-public-how-cta"
          data-testid="rtts-public-how-cta"
          href={STUDIO_COPY.publicWatchHowCtaHref}
        >
          {STUDIO_COPY.publicWatchHowCta}
        </a>
        <p className="rtts-public-how-cta-hint">
          {STUDIO_COPY.publicWatchHowCtaHint}
        </p>
      </div>
    </section>
  );
};

export default PublicWatchHowItWorks;
